module.exports = __webpack_public_path__ + "img/1613044707.bd4fcf14.png";